import { usePluginRegistry } from './PluginRegistry';

export function usePlugins(slot: string) {
  const { getPluginsForSlot, isLoading } = usePluginRegistry();
  const plugins = getPluginsForSlot(slot);
  
  return {
    plugins,
    isLoading
  };
}
